var _path, _line, _line2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisposal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2097 25.2997C12.7115 25.4869 13.27 25.232 13.4572 24.7302C13.6445 24.2285 13.3895 23.6699 12.8877 23.4827L12.2097 25.2997ZM8.23531 20.8975L7.41703 21.4179L7.41703 21.4179L8.23531 20.8975ZM6.90107 15.5095L5.93455 15.4311L5.93455 15.4311L6.90107 15.5095ZM13.9056 7.65341L14.0938 8.60466L13.9056 7.65341ZM19.4108 8.36343L18.9874 9.23579L19.4108 8.36343ZM23.3743 12.2495L24.2382 11.809L24.2382 11.809L23.3743 12.2495ZM23.238 17.5702C23.1445 18.0975 23.4961 18.6008 24.0234 18.6944C24.5507 18.788 25.054 18.4364 25.1476 17.9091L23.238 17.5702ZM12.8877 23.4827C11.3058 22.8924 9.95961 21.8021 9.05358 20.3772L7.41703 21.4179C8.54955 23.1989 10.2323 24.5618 12.2097 25.2997L12.8877 23.4827ZM9.05359 20.3772C8.14757 18.9524 7.73117 17.2708 7.8676 15.5878L5.93455 15.4311C5.76401 17.5349 6.2845 19.6368 7.41703 21.4179L9.05359 20.3772ZM7.8676 15.5878C8.00404 13.9048 8.68585 12.3123 9.80955 11.052L8.36198 9.76135C6.95736 11.3367 6.10509 13.3274 5.93455 15.4311L7.8676 15.5878ZM9.80955 11.052C10.9332 9.79171 12.4375 8.93244 14.0938 8.60466L13.7174 6.70216C11.6469 7.11189 9.7666 8.18597 8.36198 9.76135L9.80955 11.052ZM14.0938 8.60466C15.7502 8.27687 17.4683 8.49846 18.9874 9.23579L19.8342 7.49107C17.9355 6.56941 15.7878 6.29242 13.7174 6.70216L14.0938 8.60466ZM18.9874 9.23579C20.5064 9.97312 21.7433 11.1859 22.5105 12.6901L24.2382 11.809C23.2792 9.92874 21.733 8.41274 19.8342 7.49107L18.9874 9.23579ZM22.5105 12.6901C23.2776 14.1943 23.5331 15.9077 23.238 17.5702L25.1476 17.9091C25.5164 15.8309 25.1971 13.6892 24.2382 11.809L22.5105 12.6901Z",
    fill: "#DF3030"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12.6061,
    y1: 15.5152,
    x2: 18.4242,
    y2: 15.5152,
    stroke: "#F1A7A7",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.2719,
    y1: 24.424,
    x2: 15.5144,
    y2: 24.424,
    stroke: "#F1A7A7",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3932 21.3333L26.3858 23.6908C27.0265 24.1956 27.0337 25.1643 26.4006 25.6785L23.3932 28.1211",
    stroke: "#DF3030",
    strokeWidth: 1.93939,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisposal);
export default __webpack_public_path__ + "static/media/disposal.c57be8c49b08e3bcebf9d5ce094471b9.svg";
export { ForwardRef as ReactComponent };